import React from 'react'
import yochananofLogo from '../../../../assets/yochananofLogo.png'

interface IProps{
    style?:{}
}

export default function YochananofLogoComponent(props:IProps) {


    return (
        <div  style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <img style={props.style } src={yochananofLogo}/>
        </div>
    )
}
